import styled from '@emotion/styled';
import { blue, gray, primary, white } from '@styles/Colors';
import { useIsMobile, useIsTablet } from '@hooks/responsive/useIsMobile';

// components
import Typography from '@components/_atoms/Typography';
import Timeline from '@components/_organism/Timeline';

// constants
import { TypoVariant } from '@constants/atoms';
import { MOBILE_MODE, TABLET_MODE } from '@constants/size';
import { Radius } from '@styles/Radius';
import { useTranslation } from 'next-i18next';

const Content = styled.div`
  max-width: 1160px;
  margin: 0 auto;
  padding: 0 40px;

  @media ${TABLET_MODE} {
    max-width: 768px;
  }

  @media ${MOBILE_MODE} {
    max-width: 320px;
    padding: 0;
  }
`;

const DescriptionBox = styled.div`
  text-align: center;

  display: grid;
  row-gap: 16px;
`;

const TimeLineWrapper = styled.div`
  margin-top: 40px;
  position: relative;
`;

const TimeLineContent = styled.div`
  padding: 40px 0;

  display: grid;
  row-gap: 80px;
`;

const TimeLineRow = styled.div`
  display: flex;
  column-gap: 48px;
  position: relative;
`;

const HistoryBox = styled.div<{ marginTop?: string; isLeft?: boolean }>`
  flex: 1;
  display: grid;
  row-gap: 16px;

  margin-top: ${({ marginTop }) => marginTop};

  ${({ isLeft }) =>
    isLeft &&
    `
    text-align: right;
  `}
`;

const EmptyBox = styled.div`
  flex: 1;
`;

const Circle = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid ${blue.blue3};
  border-radius: ${Radius.MAXIMUM};
  background: ${white};

  position: relative;
  top: 8px;
  left: 1px;

  @media ${TABLET_MODE} {
    left: -7px;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const TimeLine = styled.div`
  width: 2px;
  height: 100%;
  background: linear-gradient(
    180deg,
    rgba(73, 128, 247, 0) 0%,
    #4980f7 8.38%,
    #4980f7 89.42%,
    rgba(73, 128, 247, 0) 100%
  );

  position: absolute;
  left: 50%;
  transform: translateY(-50%, -50%);

  @media ${TABLET_MODE} {
    left: 0;
  }
`;

export default function Section1() {
  const { t } = useTranslation('intro');

  const isMobile = useIsMobile();
  const isTablet = useIsTablet();

  return (
    <Content>
      <DescriptionBox>
        <Typography
          variant={isMobile ? TypoVariant.SH4 : isTablet ? TypoVariant.SH3 : TypoVariant.SH2}
          color={primary.blue}>
          History
        </Typography>
        <Typography
          variant={isMobile ? TypoVariant.SH2 : isTablet ? TypoVariant.H6 : TypoVariant.H5}
          color={primary.gray}>
          {t('section1.title1')}
          <br />
          {t('section1.title2')}
        </Typography>
      </DescriptionBox>

      <Timeline />
    </Content>
  );
}
